import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './plugins/element.js'
import localeElement from 'element-ui/lib/locale'
import enLocale from "element-ui/lib/locale/lang/en.js";
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import VueI18n from 'vue-i18n'
import 'vant/lib/index.css'
import 'element-ui/lib/theme-chalk/index.css';
const i18n1 = new VueI18n({
  locale: localStorage.lang || 'en',
  messages: {
    'en': {
      ...enLocale
    },
    'zh': {
      ...zhLocale
    },
  }
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})
localeElement.i18n((key, value) => i18n1.t(key, value))
Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')